/*
 * Module for touchPoint select piece of the survey labels administration
 */

define(["marionette", "backbone", "messaging/messenger", "./touchPointSelectView"], function (
  Marionette,
  Backbone,
  Messenger,
  TouchPointSelectView,
) {
  var TouchPointSelectController = Marionette.Controller.extend({
    initialize: function (options) {
      this.region = options.region;
      this.name = "touchPointSelectModule";
    },
    show: function (touchPoints, defaultTouchPoint) {
      this.touchPoints = touchPoints;
      this.touchPoints.defaultTouchPoint = defaultTouchPoint;
      this.view = new TouchPointSelectView.touchPointSelectView({ collection: touchPoints });
      this.view.on(
        "touchPoint:changed",
        function (touchPointId) {
          Messenger.save(function (success) {
            if (success) {
              Messenger.vent.trigger("change:selected:touchPoint", touchPointId);
            }
          }, this);
        },
        this,
      );

      this.view.on(
        "show",
        function () {
          this._showSubViews();
        },
        this,
      );
      this.showRegion(this.view);
    },
    _showSubViews: function () {},
  });

  return TouchPointSelectController;
});
